import React, { Fragment } from 'react';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'

import FunFact from '../../components/FunFact/FunFact';

import FeaturesSectionS2 from '../../components/FeaturesSectionS2/FeaturesSectionS2';
import TestimonialS2 from '../../components/TestimonialS2/TestimonialS2';
import BlogSection from '../../components/BlogSection/BlogSection';

import MapSection from '../../components/MapSection/MapSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'
import Footer from '../../components/footer/Footer';
import Services from '../../api/Services';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
const ServicePage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { SectionTitleShow = true } = props

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <section className={`wpo-breadcumb-area`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={'Services'} />
            </section>
            {/* <ServiceSectionS3 hclass={"wpo-service-section-s4 section-padding"} SectionTitleShow={true} ServiceBtn={true} /> */}
            <section className='section-padding pb-0'>
                <div className='container'>
                    <div className="row gy-4">
                         {SectionTitleShow && (
                            <div className="col-12 text-start">
                                <SectionTitle subtitle={'Our Services'} title={'We Provide Services'} />
                            </div>
                        )}
                        {Services.slice(0, 9).map((service, item) => (
                            <div className="col-md-4">
                                <div className="card service-card" key={item}>
                                    <div className="servic-image">
                                        <img className="image" src={service.image} alt="" />
                                    </div>
                                    <div className="content pt-4">
                                        {/* <i className={service.iconName}></i> */}
                                        <div className="text">
                                            <span>{service.id}</span>
                                            <h2><Link to={`/services/${service.slug}`} onClick={ClickHandler}>{service.title}</Link></h2>
                                            <p>{service.description}</p>
                                            <Link to={`/services/${service.slug}`} onClick={ClickHandler} className="service-single-link">
                                                <i className="flaticon-right-arrow"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <FunFact hclass={'wpo-funfact-section section-padding'} />
            {/* <ServiceSection hclass={"wpo-service-section section-padding"} /> */}
            <FeaturesSectionS2 hclass={'wpo-features-section-s2'} />
            <TestimonialS2 hclass={'wpo-testimonial-section-s2 s4 section-padding'} />
            <BlogSection hclass={'wpo-blog-section section-padding'} />
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
